/* =====================================================================
   Clairvit · page d'accueil : comportements des sections cv-*
   - carrousel héros (barres de progression, flèches, glisser, lecture auto)
   - rangées défilantes avec flèches
   - mini-carrousel d'images des cartes produit
   - vidéos muettes lues seulement quand elles sont visibles
   - bouton retour en haut, fenêtre d'inscription
   Compatible avec l'éditeur de thème (rechargement de section, sélection de bloc).
   ===================================================================== */
(function () {
  'use strict';
  /* Le fichier peut être inclus par plusieurs sections : on ne l'exécute qu'une fois */
  if (window.__cvHome) return;
  window.__cvHome = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('cv-js');

  /* ---------- Vidéos : lecture uniquement si visibles ---------- */
  var videoIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      v._cvVisible = e.isIntersecting;
      syncVideo(v);
    });
  }, { threshold: 0.2 }) : null;

  function isShown(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }

  function syncVideo(v) {
    var slide = v.closest('.cv-slide');
    var allowed = !v._cvPaused && v._cvVisible !== false && isShown(v) && (!slide || slide.classList.contains('is-cur'));
    if (reduce) allowed = false;
    if (allowed) {
      if (v.preload === 'none') v.preload = 'auto';
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    } else if (!v.paused) {
      v.pause();
    }
  }

  function initVideos(root) {
    root.querySelectorAll('video[data-cv-video]').forEach(function (v) {
      if (v._cvInit) return;
      v._cvInit = true;
      v.muted = true;
      if (videoIO) videoIO.observe(v); else syncVideo(v);
    });
  }
  window.addEventListener('resize', debounce(function () {
    document.querySelectorAll('video[data-cv-video]').forEach(syncVideo);
  }, 200));

  /* ---------- Héros ---------- */
  function initHero(hero) {
    if (hero._cv) hero._cv.destroy();
    var track = hero.querySelector('.cv-hero__track');
    var slides = track ? track.children : [];
    var prog = hero.querySelector('.cv-hero__prog');
    var bars = prog ? prog.children : [];
    var n = slides.length, cur = 0, timer = null, paused = false;
    var autoplay = hero.dataset.autoplay === 'true' && !reduce && n > 1;
    var dur = (parseFloat(hero.dataset.duration) || 6) * 1000;
    if (prog) prog.style.setProperty('--dur', dur + 'ms');
    if (!autoplay) hero.classList.add('is-static');

    function schedule() {
      clearTimeout(timer);
      if (autoplay && !paused) timer = setTimeout(function () { go(cur + 1); }, dur);
    }
    function go(i, instant) {
      if (!n) return;
      cur = (i + n) % n;
      if (instant) track.style.transition = 'none';
      track.style.transform = 'translateX(' + (-100 * cur) + '%)';
      if (instant) { void track.offsetWidth; track.style.transition = ''; }
      Array.prototype.forEach.call(slides, function (s, k) {
        var on = k === cur;
        s.classList.toggle('is-cur', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.querySelectorAll('a, button').forEach(function (a) { a.tabIndex = on ? 0 : -1; });
        s.querySelectorAll('video[data-cv-video]').forEach(syncVideo);
      });
      Array.prototype.forEach.call(bars, function (b, k) {
        b.classList.remove('is-on', 'is-done');
        b.setAttribute('aria-current', k === cur ? 'true' : 'false');
        if (k < cur) b.classList.add('is-done');
      });
      if (bars[cur]) { void bars[cur].offsetWidth; bars[cur].classList.add('is-on'); }
      hero.classList.toggle('is-lightcur', slides[cur].classList.contains('cv-slide--light'));
      schedule();
    }
    function onPrev() { go(cur - 1); }
    function onNext() { go(cur + 1); }
    var bp = hero.querySelector('.cv-hero__arrow--p'), bn = hero.querySelector('.cv-hero__arrow--n');
    if (bp) bp.addEventListener('click', onPrev);
    if (bn) bn.addEventListener('click', onNext);
    Array.prototype.forEach.call(bars, function (b, k) { b.addEventListener('click', function () { go(k); }); });

    /* Glisser au doigt ou à la souris */
    var sx = null, sy = null, moved = false;
    function down(e) { sx = e.clientX; sy = e.clientY; moved = false; }
    function up(e) {
      if (sx === null) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { moved = true; go(cur + (dx < 0 ? 1 : -1)); }
      sx = null;
    }
    function clickGuard(e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }
    var frame = hero.querySelector('.cv-hero__frame');
    frame.addEventListener('pointerdown', down);
    frame.addEventListener('pointerup', up);
    frame.addEventListener('click', clickGuard, true);

    /* Pause au survol (ordinateur) et quand l'onglet est caché */
    function pause() { paused = true; hero.classList.add('is-paused'); clearTimeout(timer); }
    function resume() { paused = false; hero.classList.remove('is-paused'); schedule(); }
    frame.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) pause(); });
    frame.addEventListener('mouseleave', function () { if (paused) { resume(); go(cur); } });
    frame.addEventListener('focusin', pause);
    function vis() { if (document.hidden) pause(); else resume(); }
    document.addEventListener('visibilitychange', vis);

    hero._cv = {
      go: go, pause: pause, resume: resume,
      destroy: function () { clearTimeout(timer); document.removeEventListener('visibilitychange', vis); }
    };
    go(0, true);
  }

  /* ---------- Rangées défilantes avec flèches ---------- */
  function initRows(root) {
    root.querySelectorAll('[data-cv-carousel]').forEach(function (c) {
      if (c._cv) return;
      c._cv = true;
      var row = c.querySelector('[data-cv-row]');
      if (!row) return;
      var prev = c.querySelector('.cv-nav--p'), next = c.querySelector('.cv-nav--n');
      function sync() {
        var max = row.scrollWidth - row.clientWidth - 2;
        if (prev) prev.disabled = row.scrollLeft <= 2;
        if (next) next.disabled = row.scrollLeft >= max;
      }
      function by(dir) { row.scrollBy({ left: dir * row.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { by(-1); });
      if (next) next.addEventListener('click', function () { by(1); });
      row.addEventListener('scroll', debounce(sync, 60), { passive: true });
      window.addEventListener('resize', debounce(sync, 150));
      sync();
    });
  }

  /* ---------- Mini-carrousel des cartes produit ---------- */
  function initGalleries(root) {
    root.querySelectorAll('[data-cv-gallery]').forEach(function (g) {
      if (g._cv) return;
      g._cv = true;
      var tr = g.querySelector('.cv-pc__tr');
      var dots = g.querySelectorAll('.cv-pc__dots i');
      var n = tr ? tr.children.length : 0;
      /* Un appui sur la photo (sans glisser) ouvre la fiche produit */
      g.addEventListener('click', function (e) {
        if (e.target.closest('.cv-pc__mini')) return;
        var a = g.closest('.cv-pc') && g.closest('.cv-pc').querySelector('.cv-pc__link');
        if (a) window.location.href = a.href;
      });
      if (n < 2) return;
      function idx() { return Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth)); }
      function paint() { var i = idx(); dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); }
      tr.addEventListener('scroll', debounce(paint, 40), { passive: true });
      g.querySelectorAll('.cv-pc__mini').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var i = (idx() + (b.classList.contains('cv-pc__mini--n') ? 1 : -1) + n) % n;
          tr.scrollTo({ left: i * tr.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });
  }

  /* ---------- Bouton pause des bannières vidéo ---------- */
  var ICON_PAUSE = '<svg viewBox="0 0 12 12" aria-hidden="true"><rect x="2" y="1.5" width="2.6" height="9" rx="1"/><rect x="7.4" y="1.5" width="2.6" height="9" rx="1"/></svg>';
  var ICON_PLAY = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M3 1.5l7 4.5-7 4.5z"/></svg>';
  function initPause(root) {
    root.querySelectorAll('[data-cv-pause]').forEach(function (b) {
      if (b._cv) return;
      b._cv = true;
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var box = b.closest('.cv-banner, .cv-mt__media, .cv-av__media') || b.parentNode;
        var vids = box.querySelectorAll('video[data-cv-video]');
        var willPause = b.getAttribute('aria-pressed') !== 'true';
        b.setAttribute('aria-pressed', willPause ? 'true' : 'false');
        b.setAttribute('aria-label', willPause ? b.dataset.labelPlay : b.dataset.labelPause);
        b.innerHTML = willPause ? ICON_PLAY : ICON_PAUSE;
        vids.forEach(function (v) { v._cvPaused = willPause; syncVideo(v); });
      });
    });
  }

  /* ---------- Retour en haut ---------- */
  function initFloat(root) {
    var top = root.querySelector('[data-cv-top]');
    if (!top || top._cv) return;
    top._cv = true;
    top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
    var onScroll = function () { top.classList.toggle('is-show', window.scrollY > 700); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Fenêtre d'inscription ---------- */
  function store(k, v) {
    try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; }
  }
  function initModal(root) {
    var m = root.querySelector('[data-cv-modal]');
    if (!m || m._cv) return;
    m._cv = true;
    var key = 'cv-popup-' + (m.dataset.version || '1');
    var inEditor = window.Shopify && window.Shopify.designMode;
    function open() { m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); var f = m.querySelector('input[type="email"]'); if (f) setTimeout(function () { f.focus(); }, 60); }
    function close() { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); store(key, String(Date.now())); }
    m.addEventListener('click', function (e) { if (e.target === m || e.target.closest('[data-cv-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && m.classList.contains('is-open')) close(); });
    document.querySelectorAll('[data-cv-open-modal]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    /* Après une inscription réussie, Shopify recharge la page avec ?customer_posted=true : on garde la fenêtre ouverte avec le message de confirmation */
    if (m.querySelector('[data-cv-posted="true"]')) { open(); store(key, 'done'); return; }
    if (inEditor) return;
    var seen = store(key);
    var days = parseFloat(m.dataset.days) || 30;
    if (seen === 'done' || (seen && Date.now() - parseInt(seen, 10) < days * 864e5)) return;
    var ratio = (parseFloat(m.dataset.scroll) || 45) / 100, shown = false;
    function check() {
      if (shown) return;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h >= ratio) { shown = true; window.removeEventListener('scroll', check); open(); }
    }
    window.addEventListener('scroll', check, { passive: true });
  }

  /* ---------- Vedettes : couleur du fondu prise dans le bas du décor ----------
     Moyenne des pixels des 18 % du bas de l'image de fond, puis ajustement pour garder
     le texte lisible (assombrie si texte blanc, éclaircie si texte noir).
     Si l'image ne peut pas être lue (autre domaine), la couleur choisie dans l'éditeur reste. */
  function lum(c) { return (0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]) / 255; }
  function sampleFade(card, img) {
    try {
      var w = img.naturalWidth, h = img.naturalHeight;
      if (!w || !h) return;
      var cv = document.createElement('canvas');
      cv.width = 24; cv.height = 6;
      var ctx = cv.getContext('2d');
      ctx.drawImage(img, 0, h * 0.82, w, h * 0.18, 0, 0, 24, 6);
      var d = ctx.getImageData(0, 0, 24, 6).data, c = [0, 0, 0], n = d.length / 4;
      for (var i = 0; i < d.length; i += 4) { c[0] += d[i]; c[1] += d[i + 1]; c[2] += d[i + 2]; }
      c = c.map(function (v) { return v / n; });
      var L = lum(c), dark = card.classList.contains('cv-hot__card--dark');
      if (!dark && L > 0.36) { var f = 0.36 / L; c = c.map(function (v) { return v * f; }); }
      if (dark && L < 0.62) { var t = (0.62 - L) / (1 - L); c = c.map(function (v) { return v + (255 - v) * t; }); }
      card.style.setProperty('--fade', 'rgb(' + c.map(Math.round).join(',') + ')');
    } catch (e) { /* image illisible : on garde la couleur choisie */ }
  }
  function initFades(root) {
    root.querySelectorAll('[data-cv-fade-auto]').forEach(function (card) {
      var img = card.querySelector('.cv-hot__bg img');
      if (!img) return;
      /* Copie légère de l'image, chargée en mode CORS (le CDN Shopify l'autorise) pour pouvoir lire ses pixels.
         L'image affichée n'est pas modifiée : si la copie échoue, rien ne casse. */
      var src = img.getAttribute('src') || '';
      if (!src) return;
      if (src.indexOf('//') === 0) src = location.protocol + src;
      src = src.replace(/([?&])width=\d+/, '$1width=200');
      if (src.indexOf('width=') === -1) src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=200';
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () { sampleFade(card, probe); };
      probe.src = src;
    });
  }

  /* ---------- Utilitaires ---------- */
  function debounce(fn, ms) { var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); }; }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-cv-hero]').forEach(initHero);
    initRows(root);
    initGalleries(root);
    initFades(root);
    initPause(root);
    initVideos(root);
    initFloat(root);
    initModal(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* ---------- Éditeur de thème ---------- */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest ? e.target.closest('.cv-slide') : null;
    if (slide) {
      var hero = slide.closest('[data-cv-hero]');
      if (hero && hero._cv) { hero._cv.pause(); hero._cv.go(Array.prototype.indexOf.call(slide.parentNode.children, slide)); hero._cv.pause(); }
    }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var hero = e.target.closest ? e.target.closest('[data-cv-hero]') : null;
    if (hero && hero._cv) hero._cv.resume();
  });
  document.addEventListener('shopify:section:select', function (e) {
    var m = e.target.querySelector && e.target.querySelector('[data-cv-modal]');
    if (m) { m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); }
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var m = e.target.querySelector && e.target.querySelector('[data-cv-modal]');
    if (m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); }
  });
})();
